module.exports = __webpack_public_path__ + "img/3.d82e6869.png";